import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import LineButton from '@components/common/lineButton';
import { SmallLoading } from '@components/loading';

import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import Svg from '@styles/icons/svg';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({ C, setMode, MODES, getMachineBrand, updateDataObj, data, validateUserAction, goBack }) => {
  const [machineBrand, setMachineBrand] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const shadowStyles = getBoxShadowStyle({type: 'Field', C});

  useEffect(() => {
    (async () => {
      const d = await getMachineBrand();
      setMachineBrand(d);
      setLoaded(true);
    })();
  }, []);

  const other = [
    {
      key: 'Other...',
    },
  ];

  const selectControl = async (item) => {
    await validateUserAction({
      ...data,
      automaticControl: false,
      machineBrandCode: item.code,
      machineBrandName: item.name,
    });
  };

  return (
    <View style={{ paddingBottom: scale(20), paddingHorizontal: isPhone ? 0 : scale(15) }}>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            <TouchableElement
              onPress={() => {
                updateDataObj({
                  machineBrandCode: null,
                  machineBrandName: null,
                });
                goBack();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), paddingHorizontal: isPhone ? scale(15) : 0, flexDirection: 'row' }]}>
                  <View style={{ marginTop: scale(2) }}>
                    <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
                  </View>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Back')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Machine Control')}</Text>
        </View>
      </View>
      <View style={{ marginTop: scale(20), paddingHorizontal: scale(15) }}>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{i18n.t('SELECT MACHINE CONTROL')}</Text>
      </View>
      {loaded ? (
        <View
          style={[
            shadowStyles,
            { marginTop: scale(5), borderRadius: scale(SCREEN_BORDER_RADIUS) },
            isPhone && {
              borderColor: C('Hairline/Light/No trans'),
              borderBottomWidth: StyleSheet.hairlineWidth,
              borderTopWidth: StyleSheet.hairlineWidth,
            },
          ]}
        >
          

          {machineBrand.map((item, index) => (
            <LineButton
              key={item.code}
              {...{
                C,
                onPress: () => selectControl(item),
                text: item.name,
                color: 'Link/Light/Primary',
                borderRadiusTop: isPhone ? false : index === 0,
                borderRadiusBottom: isPhone ? false : index === machineBrand.length - 1,
                shadow: false,
                borderBottom: index !== machineBrand.length - 1,
              }}
            />
          ))}
        </View>
      ) : (
        <SmallLoading />
      )}
      <View
        style={[
          shadowStyles,
          { marginTop: scale(20), borderRadius: scale(SCREEN_BORDER_RADIUS) },
          isPhone && {
            borderColor: C('Hairline/Light/No trans'),
            borderBottomWidth: StyleSheet.hairlineWidth,
            borderTopWidth: StyleSheet.hairlineWidth,
          },
        ]}
      >
        
        {other.map((item, index) => (
          <LineButton
            key={item.key}
            {...{
              C,
              onPress: () => {
                updateDataObj({
                  machineBrandCode: null,
                  machineBrandName: null,
                });
                setMode(MODES.MACHINE_PROTOCOL);
              },
              text: item.key,
              color: 'Link/Light/Primary',
              borderRadiusTop: isPhone ? false : index === 0,
              borderRadiusBottom: isPhone ? false : index === other.length - 1,
              shadow: false,
              borderBottom: index !== other.length - 1,
            }}
          />
        ))}
      </View>
    </View>
  );
};
